<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00114 2.75043C2.00114 2.33621 2.33692 2.00043 2.75114 2.00043C3.16535 2.00043 3.50114 2.33621 3.50114 2.75043V17.2496C3.50114 17.6638 3.16535 17.9996 2.75114 17.9996C2.33692 17.9996 2.00114 17.6638 2.00114 17.2496V2.75043Z"
      fill="currentColor"
    />
    <path
      d="M18 8C18 7.44772 17.5523 7 17 7H7C6.44772 7 6 7.44772 6 8V12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12V8Z"
      fill="currentColor"
    />
  </svg>
</template>
